import {
  WSActions,
  WSAlert,
  WSCard,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { IAccount } from "@wingspanhq/users/dist/lib/interfaces";
import { avatarBankAccount } from "../../../shared/constants/avatars";
import { selectorAccountInstitution } from "../../../shared/selectors/selectorAccountInstitution";
import { selectorAccountName } from "../../../shared/selectors/selectorAccountName";

type Props = {
  accounts: IAccount[];
  onBack?: () => void;
  onReconnect: () => void;
};

export const ReconnectPlaidAccounts: React.FC<Props> = props => {
  return (
    <WSList gap="2XL">
      <WSAlert
        theme="warning"
        icon="info-circle"
        title="Action required"
        action={{ text: "Reconnect with Plaid", onClick: props.onReconnect }}
      >
        The missing information (such as account and routing number) must be
        provided in order for the account to receive payouts through Wingspan.
        Reconnect the account with Plaid and ensure to share account and routing
        numbers after you’ve signed in to your bank account. If you continue to
        experience issues with connecting with Plaid, try adding the account by
        entering the details manually.
      </WSAlert>

      <WSCard header="Accounts with missing information">
        <WSList gap="L">
          <WSList gap="S">
            {props.accounts.map(account => (
              <WSCard
                key={account.accountId}
                header={{
                  label: {
                    text: selectorAccountInstitution(account),
                    secondaryText: selectorAccountName(account, {
                      specifyEmptyMask: true
                    }),
                    avatar: avatarBankAccount
                  }
                }}
              />
            ))}
          </WSList>

          <WSInfoBox>
            <b>Reminder</b>: These accounts cannot be used for payouts until
            required information is complete. Ensure you share account and
            routing numbers when connecting with Plaid.
          </WSInfoBox>

          <WSActions
            alignment="fill"
            buttons={[
              {
                label: "Reconnect with Plaid",
                onClick: props.onReconnect
              }
            ]}
          />
        </WSList>
      </WSCard>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Back",
            kind: "Tertiary",
            onClick: props.onBack,
            visible: !!props.onBack
          },
          {
            label: "Continue",
            disabled: true
          }
        ]}
      />
    </WSList>
  );
};
